<template>
  <form v-on:submit.prevent="searchForSendExceptions">
    <div class="col-lg-12 row">
      <template v-for="filter in searchFields.text">
        <div class="col-sm-12 col-md-6 col-lg-3" v-if="filter.title != 'documentTotal'">
          <div class="form-group">
            <label :for="filter.name" class="d-block text-center">{{t('sendExceptions' + filter.label, 'sendExceptions' + filter.label)}}</label>
            <input :id="filter.name" v-model="searchRules[filter.title]" class="form-control text-center" :placeholder="t('sendExceptions' + filter.label, 'sendExceptions' + filter.label)" type="text">
          </div>
        </div>
      </template>
      <template v-for="filter in searchFields.list">
        <div class="col-sm-12 col-md-6 col-lg-3" v-if="filter.name != 'enabled'">
          <div class="form-group">
            <label :for="filter.name" class="d-block text-center">{{t( 'sendExceptions' + filter.label, 'sendExceptions' + filter.label)}}</label>
            <select :id="filter.name" v-model="searchRules[filter.title]" :multiple="filter.name != 'enabled'" :select-size="4" class="form-control custom-select text-capitalize">
              <option :value="undefined" selected>{{t('selectAll','selectAll') }}</option>
              <template v-if="filter.name == 'customer_type'">
                <option v-for="customerType in filter.values" :value="customerType.id" :key="customerType.value_code">{{ customerType.value_name }}</option>
              </template>
              <template v-if="filter.name == 'invoice_type'">
                <option v-for="invoiceType in filter.values" :value="invoiceType.id" :key="invoiceType.value_code">{{ invoiceType.value_name }}</option>
              </template>
              <template v-if="filter.name == 'document_type'">
                <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
              </template>
              <template v-if="filter.name == 'batch_type'">
                <option v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
              </template>
              <template v-if="(filter.name == 'entity') || (filter.label == 'country')">
                <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{ entity.combined_name }}</option>
              </template>
              <template v-if="filter.name == 'entity_code'">
                <option v-for="entityCode in filter.values" :value="entityCode.id" :key="entityCode.value_code">{{ entityCode.value_name }}</option>
              </template>
              <template v-if="filter.name == 'brand'">
                <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.brand }}</option>
              </template>
            </select>
          </div>
        </div>
      </template>
      <template v-for="filter in searchFields.multiple">
        <div class="col-sm-12 col-md-6 col-lg-3" v-if="filter.name != 'enabled'">
          <div class="form-group">
            <label :for="filter.name" class="d-block text-center">{{t('sendExceptions' + filter.label, 'sendExceptions' + filter.label)}}</label>
            <select :id="filter.name" v-model="searchRules[filter.title]" :multiple="filter.name != 'enabled'" :select-size="4" class="form-control custom-select text-capitalize">
              <option :value="undefined" selected>{{t('selectAll','selectAll') }}</option>
              <template>
                <option v-for="option in filter.values" :value="option.id" :key="option.id">{{ option.value_name }}</option>
              </template>
            </select>
          </div>
        </div>
      </template>
      <template v-for="filter in searchFields.list">
        <div class="col-sm-12 col-md-6 col-lg-3" v-if="filter.name == 'enabled'">
          <div class="form-group">
            <label :for="filter.name" class="d-block text-center">{{t('sendExceptions' + filter.label, 'sendExceptions' + filter.label)}}</label>
            <select :id="filter.name" v-model="searchRules[filter.title]" :multiple="filter.name != 'enabled'" :select-size="4" class="form-control custom-select text-capitalize">
              <option :value="undefined" selected>{{t('selectAll','selectAll') }}</option>
              <template v-if="filter.name == 'enabled'">
                <option :value="'enabled'">{{t('enabledRules','enabledRules') }}</option>
                <option :value="'disabled'">{{t('disabledRules','disabledRules') }}</option>
              </template>
            </select>
          </div>
        </div>
      </template>
      <template v-for="filter in searchFields.radio">
        <template v-for="radioValue in filter.values">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <b-form-group class="mt-0" :label="t('sendExceptions' + radioValue.value_code, 'sendExceptions' + radioValue.value_code)">
              <b-form-radio v-model="searchRules[filter.title]" :name="radioValue.value_code" :value="radioValue.value_name">
                {{ t(radioValue.value_name,radioValue.value_name) }}
              </b-form-radio>
            </b-form-group>
          </div>
        </template>
      </template>
      <template v-for="filter in searchFields.check">
        <div v-if="filter.name != 'duplicate_document'" class="col-sm-12 col-md-6 col-lg-3">
          <div class="form-group">
            <b-form-checkbox
              v-model="searchRules[filter.title]"
              :value="'enabled'"
              :unchecked-value="undefined"
            >
              {{ t('sendExceptions' + filter.label, 'sendExceptions' + filter.label) }}
            </b-form-checkbox>
          </div>
        </div>
      </template>
    </div>
    <div class="col-12 row">
      <b-form-group :label="t('exceptionType', 'exceptionType')">
        <b-form-checkbox-group id="rules" v-model="searchRules.rule" name="rules">
          <template v-for="rule in rules">
            <b-form-checkbox type="checkbox" :value="rule.id" class="col-12">{{ rule.description_short }}</b-form-checkbox>
          </template>
        </b-form-checkbox-group>
      </b-form-group>
    </div>
    <div class="row justify-content-end">
      <button v-if="!isLoading" class="btn btn-primary ml-2" type="submit">{{ t('searchButtonText','searchButtonText') }}</button>
      <b-button v-if="isLoading" class="ml-2" variant="primary" disabled>
        <b-spinner small type="grow"></b-spinner>
         {{ t('searchButtonText','searchButtonText') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
//import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'search_rules',
  inject: [
    'refreshResults'
  ],
  data () {
    return {
      isLoading: false,
      searchRules: {
        rule: []
      }
    }
  },
  computed:{
    //...mapGetters(['getResponseInfo']),
    searchFields() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesSearchFilters']
    },
    searchAttributes() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesAttributes']
    },
    documentTypes() {
      return this.$store.getters['sendExceptionsStore/getDocTypes']
    },
    batchTypes() {
      return this.$store.getters['sendExceptionsStore/getBatchTypes']
    },
    entities() {
      return this.$store.getters['sendExceptionsStore/getEntities']
    },
    brands() {
      return this.$store.getters['sendExceptionsStore/getBrands']
    },
    rules() {
      return this.$store.getters['sendExceptionsStore/getRules']
    }
  },
  methods:{
    searchForSendExceptions() {
      this.searchRules.page = 1

      if(this.$route.query.per_page) {
        this.searchRules.per_page = this.$route.query.per_page
      } else {
        this.searchRules.per_page = 20
      }

      this.refreshResults({searchFrom: 'searchBar', searchData: this.searchRules})
      this.initializeLists()
    },
    initializeLists() {
      for (const index in this.searchFields) {
        for (const indexNumber in this.searchFields[index]) {
          if((this.searchFields[index][indexNumber]['type'] == 'list')) {
            this.searchRules[this.searchFields[index][indexNumber]['title']] = [];
          }
        }
      }
    }
  },
  created() {
    this.initializeLists()
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesAttributes')
    this.$store.dispatch('sendExceptionsStore/getBatchTypes')
    this.$store.dispatch('sendExceptionsStore/getEntities')
    this.$store.dispatch('sendExceptionsStore/getBrands')
    this.$store.dispatch('sendExceptionsStore/getDocumentTypes')
    /*
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesAttributes').then(
      () => {
        if(this.searchAttributes.includes('batch_type')) {
          this.$store.dispatch('sendExceptionsStore/getBatchTypes')
        }

        if(this.searchAttributes.includes('entity')) {
          this.$store.dispatch('sendExceptionsStore/getEntities')
        }

        if(this.searchAttributes.includes('brand')) {
          this.$store.dispatch('sendExceptionsStore/getBrands')
        }

        if(this.searchAttributes.includes('document_type')) {
          this.$store.dispatch('sendExceptionsStore/getDocumentTypes')
        }
      }
    )*/
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesSearchFilters')

    if(Object.keys(this.$route.query).length) {
        //TODO enhancement - generate fields based on client's searchAttributes
        if(this.$route.query.ruleId) {
          this.searchRules.ruleId = this.$route.query.ruleId
        }

        if(this.$route.query.customerRef) {
          this.searchRules.customerRef = this.$route.query.customerRef
        }

        if(this.$route.query.accountNumber) {
          this.searchRules.accountNumber = this.$route.query.accountNumber
        }

        if(this.$route.query.docReference) {
          this.searchRules.docReference = this.$route.query.docReference
        }

        if(this.$route.query.documentType) {
          this.searchRules.documentType = this.$route.query.documentType
        }

        if(this.$route.query.country) {
          this.searchRules.country = this.$route.query.country
        }

        if(this.$route.query.entity) {
          this.searchRules.entity = this.$route.query.entity
        }

        if(this.$route.query.entityCode) {
          this.searchRules.entityCode = this.$route.query.entityCode
        }

        if(this.$route.query.batchType) {
          this.searchRules.batchType = this.$route.query.batchType
        }

        if(this.$route.query.brand) {
          this.searchRules.brand = this.$route.query.brand
        }

        if(this.$route.query.customerType) {
          this.searchRules.customerType = this.$route.query.customerType
        }

        if(this.$route.query.documentValue) {
          this.searchRules.documentValue = this.$route.query.documentValue
        }

        if(this.$route.query.docReference) {
          this.searchRules.docReference = this.$route.query.docReference
        }

        if(this.$route.query.docDuplicate) {
          this.searchRules.docDuplicate = this.$route.query.docDuplicate
        }

        if(this.$route.query.rule) {
          if(Array.isArray(this.$route.query.rule)) {
            this.searchRules.rule = this.$route.query.rule
          } else {
            this.searchRules.rule = [this.$route.query.rule]
          }
        }

        if(this.$route.query.enabled) {
          this.searchRules.enabled = this.$route.query.enabled
        }
    }

  },
  components:{
    //ResponseInfo
  }
}
</script>

<style scoped>

</style>
